import { useRef } from 'react';
import { triggerSnowplowEventProductInteractions } from '@bigbasket/snowplow';
import ReactImageZoom from 'react-image-zoom';

const ImageMagnifier = ({ l = '', xxl = '', productId, index = 0 }) => {
  const imageRef = useRef();

  const handleSnowPlow = (zIndexValue) => {
    const addButton = document.getElementById('add-button');
    if (addButton) {
      addButton.style.zIndex = zIndexValue;
    }
    triggerSnowplowEventProductInteractions({
      EventName: 'image_zoomed',
      ScreenType: 'pd',
      ScreenTypeID: Number(productId),
      SkuID: Number(productId),
      InPageContext: `${index + 1}`,
    });
  };
  if (!l || !xxl) {
    return <div className="flex items-center justify-center w-full h-full">Input props are not correct</div>;
  }

  return (
    <div className="flex flex-col w-full h-full items-center justify-center" ref={imageRef}>
      <div className="lg:w-82 xl:w-100.2 lg:h-82 xl:h-100.2">
        <div
          className={`h-full w-full`}
          onMouseOver={() => {
            handleSnowPlow(-1);
          }}
          onMouseLeave={() => {
            handleSnowPlow(0);
          }}>
          <ReactImageZoom img={l} zoomWidth={180} zoomStyle={'width:400px; opacity:1'} offset={{ vertical: 0, horizontal: 10 }} zoomLensStyle={'z-index: -1'} />
        </div>
      </div>
    </div>
  );
};

export default ImageMagnifier;
